import React from 'react';
import { Award, Users, TrendingUp, Shield, Check } from 'lucide-react';
import { credibilityStats, credibilityFeatures } from '@/data/mock';

const CredibilitySection = () => {
  const icons = [Award, Users, TrendingUp, Shield];

  return (
    <section className="relative py-20 bg-slate-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #64748b 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {credibilityStats.map((stat, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={stat.id}
                className="group relative p-6 bg-white border border-slate-200 rounded-2xl hover:border-cyan-400/50 hover:shadow-xl hover:shadow-cyan-500/10 transition-all duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-teal-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500/10 to-teal-500/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-cyan-500" />
                  </div>
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-teal-500 bg-clip-text text-transparent mb-2">
                    {stat.value}
                  </div>
                  <p className="text-slate-500 text-sm">{stat.label}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Features Strip */}
        <div className="bg-white border border-slate-200 rounded-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {credibilityFeatures.map((feature, index) => (
              <div
                key={index}
                className="flex items-start gap-3"
              >
                <div className="w-6 h-6 rounded-full bg-cyan-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 rounded-full bg-cyan-500" />
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
